export const agentImportPermitFraud =
  'Select Agent/Import Permit Fraud Complaint'
export const childSupport = 'Federal Child Support Complaint'
export const complaintTypeChoice = 'File a Complaint'
export const feedback = 'Share Your Feedback'
export const fraudWasteAbuse = 'Fraud, Waste, or Abuse Complaint'
export const fugitive = 'Report a fugitive'
export const grantContractFraud = 'Grant or Contract Fraud Complaint'
export const healthcareFraud = 'Report Healthcare Fraud'
export const ihsChildAbuse = 'Report Child or Sexual Abuse to IHS'
export const medicalIdTheft = 'Medical Identity Theft'
export const opDivReferral = 'Operating Division Referral'
export const otherComplaint = 'Other Complaint'
export const qualityOfCare = 'Report Quality of Care Complaint'
export const thankYou = 'Thank you'
export const whistleblowerRetaliation = 'Report Whistleblower Retaliation'
